import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { getAddressProvince } from "../redux/handlers/master/getAddressProvince.handler";
import { getAddressDistrict } from "../redux/handlers/master/getAddressDistrict.handler";
import { getAddressSubdistrict } from "../redux/handlers/master/getAddressSubdistrict.handler";
import AddressSelect, { useAddressRows } from "./AddressSelect";
export default function ThaiAddressSelect(param) {
    var values = param.values, onChange = param.onChange;
    var provinces = useAddressRows(getAddressProvince, "getAddressProvinceReducer");
    var province = provinces.rows.find(function(row) {
        return String(row.province_id) === String(values.sh_branch_thprovince_id);
    });
    var provinceid = province === null || province === void 0 ? void 0 : province.province_provinceid;
    var districts = useAddressRows(getAddressDistrict, "getAddressDistrictReducer", provinceid, undefined, Boolean(provinceid));
    var district = districts.rows.find(function(row) {
        return String(row.district_id) === String(values.sh_branch_thdistrict_id);
    });
    var districtid = district === null || district === void 0 ? void 0 : district.district_districtid;
    var children = useAddressRows(getAddressSubdistrict, "getAddressSubdistrictReducer", provinceid, districtid, Boolean(provinceid && districtid));
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(AddressSelect, {
                label: "จังหวัด",
                value: values.sh_branch_thprovince_id,
                source: provinces,
                idKey: "province_id",
                nameKey: "province_name",
                onChange: function(option) {
                    var _option_value;
                    return onChange({
                        sh_branch_thprovince_id: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null,
                        sh_branch_thdistrict_id: null,
                        sh_branch_thsubdistrict_id: null
                    });
                }
            }),
            /*#__PURE__*/ _jsx(AddressSelect, {
                label: "อำเภอ/เขต",
                value: values.sh_branch_thdistrict_id,
                source: districts,
                idKey: "district_id",
                nameKey: "district_name",
                disabled: !provinceid,
                onChange: function(option) {
                    var _option_value;
                    return onChange({
                        sh_branch_thdistrict_id: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null,
                        sh_branch_thsubdistrict_id: null
                    });
                }
            }),
            /*#__PURE__*/ _jsx(AddressSelect, {
                label: "ตำบล/แขวง",
                value: values.sh_branch_thsubdistrict_id,
                source: children,
                idKey: "subdistrict_id",
                nameKey: "subdistrict_name",
                disabled: !districtid,
                onChange: function(option) {
                    var _option_value;
                    return onChange({
                        sh_branch_thsubdistrict_id: (_option_value = option === null || option === void 0 ? void 0 : option.value) !== null && _option_value !== void 0 ? _option_value : null
                    });
                }
            })
        ]
    });
}
